import React, { useEffect, useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";
import Api from "../../Api/Api";

export default function ColumnPermissionDialog({
  open,
  onClose,
  column,
  users = [],
  columnRestrictions,
  setColumnRestrictions,
}) {
  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    if (open && column) {
      setSelectedUsers(columnRestrictions?.[column] || []);
    }
  }, [open, column, columnRestrictions]);

  const handleSave = async () => {
    console.log({
      column,
      users: selectedUsers,
    });

    await Api.post("/dashboard/column-permissions", {
      column,
      users: selectedUsers,
    });

    setColumnRestrictions((prev) => ({
      ...prev,
      [column]: selectedUsers,
    }));

    onClose();
  };

  const handleRemoveRestriction = async () => {
    try {
      await Api.delete(`/dashboard/column-permissions/${column}`);

      setColumnRestrictions((prev) => {
        const updated = { ...prev };
        delete updated[column];
        return updated;
      });

      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  const ALL_USERS_OPTION = {
    id: "__ALL_USERS__",
    name: "Account + Agents",
  };
  console.log(users);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Column Permission</DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Column:
          <strong> {column}</strong>
        </Typography>

        <Autocomplete
          multiple
          options={[
            ALL_USERS_OPTION,
            ...users.filter((u) => u.process === 5 || u.process === 2),
          ]}
          getOptionLabel={(option) => option.name}
          value={users.filter((u) => selectedUsers.includes(u.id))}
          onChange={(e, value) => {
            const hasAllUsers = value.some((v) => v.id === "__ALL_USERS__");

            if (hasAllUsers) {
              const accountAndAgents = users.filter(
                (u) => u.process === 5 || u.process === 2,
              );

              setSelectedUsers(accountAndAgents.map((u) => u.id));
              return;
            }

            setSelectedUsers(value.map((v) => v.id));
          }}
          renderInput={(params) => (
            <TextField {...params} label="Allowed Users" />
          )}
        />
      </DialogContent>

      <DialogActions>
        <Button color="error" onClick={handleRemoveRestriction}>
          Remove Restriction
        </Button>

        <Button onClick={onClose}>Cancel</Button>

        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
